<template>
  <div
    class="fixed-sidebar"
    :class="{ 'is-collapsed': collapsed }"
    :style="{ right: right + 'px', bottom: bottom + 'px' }"
  >
    <div class="sidebar-list">
      <!-- 联系客服 -->
      <div class="sidebar-item" @click="handleContact">
        <div class="item-icon">
          <i class="el-icon-service"></i>
        </div>
        <div class="item-label">问题咨询</div>
      </div>

      <!-- 返回顶部 -->
      <div class="sidebar-item" @click="handleBackTop">
        <div class="item-icon">
          <i class="el-icon-arrow-up"></i>
        </div>
        <div class="item-label">返回顶部</div>
      </div>
    </div>

    <!-- 收起/展开 -->
    <div class="sidebar-toggle" @click="toggleCollapse">
      <i :class="collapsed ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FixedSidebar',
  props: {
    right: {
      type: Number,
      default: 0
    },
    bottom: {
      type: Number,
      default: 100
    },
    defaultCollapsed: {
      type: Boolean,
      default: false
    },
    /**
     * 滚动容器选择器
     * 例如 ".app-main"、".el-scrollbar__wrap"
     * 不传则自动查找
     */
    scrollContainerSelector: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      collapsed: this.defaultCollapsed,
      scrollContainer: null,
      inited: false
    }
  },
  mounted: function() {
    var self = this
    this.$nextTick(function() {
      setTimeout(function() {
        self.initScrollContainer()
      }, 100)
    })
  },
  methods: {
    toggleCollapse: function() {
      this.collapsed = !this.collapsed
    },

    handleContact: function() {
      this.$emit('contact')
    },

    handleBackTop: function() {
      if (!this.inited) {
        console.warn('[FixedSidebar] 滚动容器尚未初始化，尝试重新初始化...')
        this.initScrollContainer()
        return
      }
      this.scrollToTop()
    },

    // ==========================================
    // 滚动容器初始化
    // ==========================================
    initScrollContainer: function() {
      var self = this

      // 1. 优先使用手动传入的选择器
      if (this.scrollContainerSelector) {
        var manualEl = document.querySelector(this.scrollContainerSelector)
        if (manualEl) {
          this.scrollContainer = manualEl
          this.inited = true
          console.log('[FixedSidebar] 使用手动指定的滚动容器:', this.scrollContainerSelector)
          return
        }
        console.warn('[FixedSidebar] 未找到手动指定的滚动容器:', this.scrollContainerSelector)
      }

      // 2. 自动向上查找（从组件自身开始）
      var node = this.$el
      while (node && node !== document.body) {
        var style = window.getComputedStyle(node)
        var overflowY = style.overflowY
        var overflow = style.overflow
        var hasScroll = (overflowY === 'auto' || overflowY === 'scroll' ||
                         overflow === 'auto' || overflow === 'scroll')
        var isScrollable = node.scrollHeight > node.clientHeight

        if (hasScroll && isScrollable) {
          this.scrollContainer = node
          this.inited = true
          console.log('[FixedSidebar] 自动找到滚动容器:', node.tagName, node.className || node.id)
          return
        }
        node = node.parentElement
      }

      // 3. 全局搜索：找当前 scrollTop > 0 的元素（最靠谱）
      var allElements = document.querySelectorAll('*')
      for (var i = 0; i < allElements.length; i++) {
        var el = allElements[i]
        var elStyle = window.getComputedStyle(el)
        var elOverflowY = elStyle.overflowY
        var elOverflow = elStyle.overflow
        var elHasScroll = (elOverflowY === 'auto' || elOverflowY === 'scroll' ||
                           elOverflow === 'auto' || elOverflow === 'scroll')
        var elIsScrollable = el.scrollHeight > el.clientHeight

        if (elHasScroll && elIsScrollable && el.scrollTop > 0) {
          this.scrollContainer = el
          this.inited = true
          console.log('[FixedSidebar] 全局搜索找到滚动容器（scrollTop>0）:', el.tagName, el.className || el.id)
          return
        }
      }

      // 4. 检查 document.documentElement
      var html = document.documentElement
      var htmlStyle = window.getComputedStyle(html)
      var htmlHasScroll = (htmlStyle.overflowY === 'auto' || htmlStyle.overflowY === 'scroll' ||
                           htmlStyle.overflow === 'auto' || htmlStyle.overflow === 'scroll')
      if (htmlHasScroll && html.scrollHeight > html.clientHeight) {
        this.scrollContainer = html
        this.inited = true
        console.log('[FixedSidebar] 滚动容器为 document.documentElement')
        return
      }

      // 5. 降级为 window
      this.scrollContainer = window
      this.inited = true
      console.log('[FixedSidebar] 降级为 window 滚动')
    },

    // ==========================================
    // 滚动相关方法
    // ==========================================
    getScrollTop: function() {
      if (this.scrollContainer === window) {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      }
      return this.scrollContainer.scrollTop || 0
    },

    setScrollTop: function(val) {
      if (this.scrollContainer === window) {
        window.scrollTo(0, val)
      } else {
        this.scrollContainer.scrollTop = val
      }
    },

    smoothScrollTo: function(top, duration) {
      duration = duration || 400
      var container = this.scrollContainer
      var isWindow = container === window
      var start = this.getScrollTop()
      var distance = top - start
      if (Math.abs(distance) < 1) return

      var startTime = null
      var easeOutQuad = function(t) {
        return 1 - (1 - t) * (1 - t)
      }

      var step = function(timestamp) {
        if (!startTime) startTime = timestamp
        var elapsed = timestamp - startTime
        var progress = Math.min(elapsed / duration, 1)
        var current = Math.round(start + distance * easeOutQuad(progress))

        if (isWindow) {
          window.scrollTo(0, current)
        } else {
          container.scrollTop = current
        }

        if (progress < 1) {
          requestAnimationFrame(step)
        }
      }

      requestAnimationFrame(step)
    },

    scrollToTop: function() {
      this.smoothScrollTo(0, 400)
    }
  }
}
</script>

<style scoped>
.fixed-sidebar {
  position: fixed;
  z-index: 999;
  background: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border-radius: 4px 0 0 4px;
  overflow: hidden;
  transition: all 0.3s ease;
  width: 68px;
}

.fixed-sidebar.is-collapsed {
  width: 36px;
}

.sidebar-list {
  display: flex;
  flex-direction: column;
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 1px solid #f0f0f0;
  user-select: none;
}

.sidebar-item:last-child {
  border-bottom: none;
}

.sidebar-item:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.item-icon {
  font-size: 20px;
  margin-bottom: 4px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-label {
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  transition: opacity 0.3s;
}

.is-collapsed .item-label {
  opacity: 0;
  width: 0;
  height: 0;
  overflow: hidden;
}

.is-collapsed .item-icon {
  margin-bottom: 0;
}

.sidebar-toggle {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ebeef5;
  cursor: pointer;
  color: #909399;
  font-size: 14px;
  transition: all 0.2s;
  user-select: none;
}

.sidebar-toggle:hover {
  background-color: #f5f7fa;
  color: #409eff;
}
</style>